export default __webpack_public_path__ + "static/media/icons8-trash.35b2efd0.svg";